import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Portfoliotopsection from "../components/Portfoliotopsection";
import WebportfolioSection from "../components/webportfolioSection";
import okbajuLogo from "../images/okbaju-logo.png";
import storiseLogo from "../images/storise-logo.png";
import okbajuAppPortfolio from "../images/comp/okbaju-app.webp";
import storiseAppPortfolio from "../images/comp/storise-app.webp";
import figma from "../images/figma.png";
import php from "../images/php.png";
import mysql from "../images/mysql.png";
import laravel from "../images/laravel.png";

const AppportfolioPage = () => {
  const portfolioData = [
    {
      title: "Portfolio",
      description:
        "A Showcase of Innovation, Creativity & impactful At Hope Websolution, we don’t just build websites and apps — we craft digital experiences that make a difference. Our portfolio reflects the diverse range of projects we’ve delivered across various industries, combining creativity, technology, and user-centered design. Whether it’s a sleek mobile app, a powerful web platform, or a user-friendly e-commerce solution — our work speaks for itself.",
    },
  ];
  const appportfolioData = [
    {
      id: "okbaju-app",
      logo: okbajuLogo,
      title: "Home services at your doorstep",
      description:
        "We bring top-quality home services directly to you, making home maintenance easier than ever. Whether you need repairs, cleaning, or specialized assistance, our platform connects you with skilled professionals in your area.",
      features: [
        "Verified Professionals",
        "Instant Booking & Scheduling",
        "Transparent Pricing",
        "Wide Range of Services",
      ],
      technologies: ["React", "Node.js", "MongoDB", "Express"],
      technologiesimage: [figma, php, mysql, laravel],
      portfolioimage: okbajuAppPortfolio,
      buttontext: "View Details",
      buttonlink: "/app-portfolios-details/okbaju-app",
    },
    {
      id: "storise-app",
      logo: storiseLogo,
      title: "Read. Listen. Rise. All-in-One Streaming App",
      description:
        "We bring top-quality home services directly to you, making home maintenance easier than ever. Whether you need repairs, cleaning, or specialized assistance, our platform connects you with skilled professionals in your area.",
      features: [
        "Real Voices, Real Stories",
        "Effortless Storytelling",
        "Interactive Features",
        "Multi-Genre Support",
      ],
      technologies: ["React", "Node.js", "MongoDB", "Express"],
      technologiesimage: [figma, php, mysql, laravel],
      portfolioimage: storiseAppPortfolio,
      buttontext: "View Details",
      buttonlink: "/app-portfolios-details/storise-app",
    },
  ];
  return (
    <div>
      <Header />
      {portfolioData.map((portfolio) => (
        <Portfoliotopsection
          key={portfolio.id}
          title={portfolio.title}
          description={portfolio.description}
        />
      ))}
      <section className="planning-section services-section">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-9  mb-lg-0 position-relative text-center">
              <h2 className="title">App Portfolios</h2>
            </div>
          </div>
        </div>
      </section>
      {appportfolioData.map((item, index) => (
        <WebportfolioSection
          key={index}
          logo={item.logo}
          title={item.title}
          description={item.description}
          features={item.features}
          technologies={item.technologies}
          technologiesimage={item.technologiesimage}
          buttontext={item.buttontext}
          buttonlink={item.buttonlink}
          portfolioimage={item.portfolioimage}
        />
      ))}
      <Footer />
    </div>
  );
};

export default AppportfolioPage;
